import InboxIcon from '@mui/icons-material/MoveToInbox';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { ApplicationRoutes } from './ApplicationRoutes';


export interface ISidenavRoutes {
    type: "title" | "list" | "item" | "divder",
    name: string,
    icon: any,
    items: ISidenavItems[] | null,
    roles: string[],
    route?: string
}

interface ISidenavItems {
    type: "item",
    name: string,
    route: string
}

export const SidenavRoutes: ISidenavRoutes[] = [
    {
        type: "title",
        name: "Pages",
        icon: <InboxIcon />,
        items: null,
        roles: [],
    },

    {
        type: "list",
        name: "Knowledge Base",
        icon: <MenuBookIcon />,
        roles: ApplicationRoutes().KnowledgeBaseDashboard.roles,
        items: [
            { type: "item", name: "Dashboard", route: ApplicationRoutes().KnowledgeBaseDashboard.route },
            { type: "item", name: "Articles", route: ApplicationRoutes().KnowledgeBaseArticles.route },
            { type: "item", name: "Categories", route: ApplicationRoutes().KnowledgeBaseCategories.route },
            { type: "item", name: "FAQ Library", route: ApplicationRoutes().KnowledgeBaseFaqs.route },
            { type: "item", name: "Analytics", route: ApplicationRoutes().KnowledgeBaseAnalytics.route },
            { type: "item", name: "AI Optimization", route: ApplicationRoutes().KnowledgeBaseAiOptimization.route },
            { type: "item", name: "Translation Center", route: ApplicationRoutes().KnowledgeBaseTranslations.route },
            { type: "item", name: "Settings", route: ApplicationRoutes().KnowledgeBaseSettings.route }
        ]
    },
    {
        type: "item",
        name: "Entities",
        icon: <InboxIcon />,
        roles: ApplicationRoutes().Entities.roles,
        route: ApplicationRoutes().Entities.route,
        items: null
    },
    {
        type: "item",
        name: "Booking Types",
        icon: <InboxIcon />,
        items: null,
        route: ApplicationRoutes().BookingType.route,
        roles: ApplicationRoutes().BookingType.roles,
    },
    {
        type: "item",
        name: "Feature Banners",
        icon: <InboxIcon />,
        items: null,
        route: ApplicationRoutes().FeatureBanners.route,
        roles: ApplicationRoutes().FeatureBanners.roles,
    },
    {
        type: "item",
        name: "Country Tax Setup",
        icon: <InboxIcon />,
        items: null,
        route: ApplicationRoutes().CountryTaxSetups.route,
        roles: ApplicationRoutes().CountryTaxSetups.roles,
    },
    {
        type: "item",
        name: "Insurance Company",
        icon: <InboxIcon />,
        items: null,
        route: ApplicationRoutes().InsuranceCompanies.route,
        roles: ApplicationRoutes().InsuranceCompanies.roles,
    },
    {
        type: "item",
        name: "Calendar",
        icon: <InboxIcon />,
        items: null,
        route: ApplicationRoutes().Calendars.route,
        roles: ApplicationRoutes().Calendars.roles,
    },
    {
        type: "list",
        name: "Incomplete",
        icon: <InboxIcon />,
        roles: ApplicationRoutes().IncompleteEntities.roles,
        items: [
            {
                type: "item",
                name: "Incomplete Entities",
                route: ApplicationRoutes().IncompleteEntities.route
            }
        ]
    },
    {
        type: "list",
        name: "Pending Approval",
        icon: <InboxIcon />,
        roles: ApplicationRoutes().PendingApprovalServices.roles,
        items: [
            {
                type: "item",
                name: "Services",
                route: ApplicationRoutes().PendingApprovalServices.route
            }
        ]
    },
    {
        type: "item",
        name: "Contracts",
        icon: <InboxIcon />,
        items: null,
        route: ApplicationRoutes().Contracts.route,
        roles: ApplicationRoutes().Contracts.roles,
    },
    {
        type: "item",
        name: "Subscription Levels",
        icon: <InboxIcon />,
        items: null,
        route: ApplicationRoutes().SubscriptionLevels.route,
        roles: ApplicationRoutes().SubscriptionLevels.roles,
    },
    {
        type: "item",
        name: "Subscription Monthly Period Details",
        icon: <InboxIcon />,
        items: null,
        route: ApplicationRoutes().SubscriptionMonthlyPeriodDetails.route,
        roles: ApplicationRoutes().SubscriptionMonthlyPeriodDetails.roles,
    },
    {
        type: "list",
        name: "Treatments",
        icon: <MedicalServicesIcon />,
        roles: ApplicationRoutes().Treatments.roles,
        items: [
            {
                type: "item",
                name: "Unit of Measure",
                route: ApplicationRoutes().TreatmentsUnitOfMeasure.route
            },
            {
                type: "item",
                name: "Body images",
                route: ApplicationRoutes().TreatmentBodyImages.route
            },
            {
                type: "item",
                name: "Treatments",
                route: ApplicationRoutes().Treatments.route
            }
        ]
    },
]
